import React from 'react';
import { connect } from 'react-redux';
import { Grid, Typography, Button, IconButton, Drawer, InputAdornment } from '@mui/material';
import Formsy from 'formsy-react';
import { Helmet } from 'react-helmet';
import * as qs from 'query-string';
import _ from 'lodash';
import CardGallery from 'components/CardGallery';
import SelectInput from 'components/inputs/SelectInput';
import TextInput from 'components/inputs/TextInput';
import SearchIcon from '@mui/icons-material/Search';
import { searchProducts } from 'actions/ProductActions';
import { appendSeoBrand } from 'utils/seo';
import { FormattedMessage, injectIntl } from 'react-intl';

export class ProductSearchPage extends React.Component {
  constructor(props) {
    super(props);

    const params = qs.parse(location.search);

    this.state = {
      search: params,
      filtersOpen: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.searchProducts(window.SITE_ID, this.state.search, this.props.locale);
  }

  handleSubmit(data, _resetForm, _invalidateForm) {
    this.setState({search: Object.assign({}, this.state.search, data), filtersOpen: false}, () => this.triggerSearch());
  }

  triggerSearch() {
    // Push search params into URL
    window.history.replaceState(null, null, `${location.pathname}?${qs.stringify(this.state.search)}`);

    this.props.searchProducts(window.SITE_ID, this.state.search, this.props.locale);
  }

  sortOptions() {
    const { intl } = this.props;

    return ([
      {label: intl.formatMessage({id: "search.featured", defaultMessage: 'Featured'}), value: 'featured'},
      {label: intl.formatMessage({id: "search.latest", defaultMessage: 'Latest'}), value: 'latest'},
      {label: intl.formatMessage({id: "search.alphabetically", defaultMessage: 'Alphabetically - A to Z'}), value: 'name'},
      {label: intl.formatMessage({id: "search.alphabetically_reverse", defaultMessage: 'Alphabetically - Z to A'}), value: 'name_reverse'}
    ]);
  }

  render() {
    const { site, products, isSearching, intl } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{appendSeoBrand('Products')}</title>
          <meta name="robots" content={window.APP_ENV === 'production' ? 'index' : 'noindex'} />
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Typography variant="h3" component="h1" align="center" paragraph><FormattedMessage id="landing.products" defaultMessage="Products" /></Typography>

        <Formsy onValidSubmit={this.handleSubmit}>
          <TextInput type="search" name="search" value={this.state.search.search} label={intl.formatMessage({id: "order.search", defaultMessage: "Search"})} inlineLabel
            inputProps={{
              endAdornment: <InputAdornment position="end"><IconButton type="submit" disableRipple={false}><SearchIcon titleAccess='Search' /></IconButton></InputAdornment>
            }}
          />
          {products.length > 0 &&
            <React.Fragment>
              <div style={{width: '250px', display: 'inline-block'}}>
                <SelectInput name="sort_order" label="" options={this.sortOptions()} value={this.state.search.sort_order || "featured"} onChange={(e) => this.handleSubmit({sort_order: e.target.value})} />
              </div>
              <Button variant="contained" onClick={() => this.setState({filtersOpen: true})} style={{float: 'right', marginTop: '20px'}}>
                <FormattedMessage id="search.filters" defaultMessage="Filters" /> ({Object.values(_.omit(this.state.search, ['search', 'sort_order'])).filter(Boolean).length})
              </Button>
            </React.Fragment>
          }
        </Formsy>

        <Drawer anchor="right" open={this.state.filtersOpen} onClose={() => {this.setState({filtersOpen: false})}} PaperProps={{style: {width: '300px', padding: '1em'}}}>
          <Typography variant="h5" align="center" paragraph><FormattedMessage id="search.filters" defaultMessage="Filters" /></Typography>

          <Formsy onValidSubmit={this.handleSubmit}>
            <SelectInput name="tag" label={intl.formatMessage({id: "search.tag", defaultMessage: 'Tag'})} options={site.tags.map(tag => ({value: tag.id, label: tag.name}))} value={this.state.search.tag} />

            <Grid container spacing={1} justifyContent="center">
              <Grid size={{xs: 6}}>
                <TextInput type="number" name="price_min" label={intl.formatMessage({id: "search.price_min", defaultMessage: 'Price - Min'})} value={this.state.search.price_min} />
              </Grid>
              <Grid size={{xs: 6}}>
                <TextInput type="number" name="price_max" label={intl.formatMessage({id: "search.price_max", defaultMessage: 'Price - Max'})} value={this.state.search.price_max} />
              </Grid>
            </Grid>

            <Button type="submit" variant="contained" color="primary" style={{marginTop: '3em'}}>
              <FormattedMessage id="search.apply" defaultMessage="Apply" />
            </Button>
            <Button variant="contained" style={{marginTop: '3em', float: 'right'}} onClick={() => this.setState({search: _.pick(this.state.search, 'search', 'sort_order')}, this.handleSubmit({}))}>
              <FormattedMessage id="search.clear_filters" defaultMessage="Clear Filters" />
            </Button>
          </Formsy>
        </Drawer>

        {!isSearching && products.length === 0 ?
          <React.Fragment>
            <Typography variant="h4" color="primary" paragraph style={{marginTop: '25px'}}>
              <FormattedMessage id="search.no_results" defaultMessage="No results found" />
            </Typography>
            <Typography paragraph><FormattedMessage id="search.sorry" defaultMessage="Sorry, we couldn't find anything for that search" /></Typography>
          </React.Fragment>
        :
          <CardGallery site={site} cardDesigns={products} hideSearchBar cardsPerPage={24} />
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    site: state.site.site,
    locale: state.locale.locale,
    isSearching: state.product.isSearching,
    products: state.product.searchProducts
  };
}

const mapDispatchToProps = {
  searchProducts: (siteId, searchParams, locale) => searchProducts(siteId, searchParams, locale)
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductSearchPage));
